import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import Auth0ProviderWithHistory from './routes/Auth/components/Auth0ProviderWithHistory';
import Authentication from './components/Authentication';
import store from './store/store';
import App from './App';
import BridgMuiTheme from './BridgMuiTheme';

/* LaunchDarkly ClientIDs for QA/Prod */
const launchDarklyEnvironments = {
  production: '5b92e71964e7b428ec862be2',
  test: '5b92e71964e7b428ec862be1',
};

// Current LaunchDarkly Environment
const currentLaunchDarklyEnvironment = window?.location?.href?.includes('cloud.bridg.com')
  ? launchDarklyEnvironments.production
  : launchDarklyEnvironments.test;

(async () => {
  const container = document.getElementById('root');
  const root = createRoot(container);

  // Initialize Launch Darkly
  const LDProvider = await asyncWithLDProvider({
    clientSideID: currentLaunchDarklyEnvironment,
  });

  root.render(
    <ThemeProvider theme={BridgMuiTheme}>
      <Provider store={store}>
        <BrowserRouter>
          <Auth0ProviderWithHistory>
            <LDProvider>
              <Authentication>
                <App />
              </Authentication>
            </LDProvider>
          </Auth0ProviderWithHistory>
        </BrowserRouter>
      </Provider>
    </ThemeProvider>
  );
})();
